<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          Site
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Site</a>
          </li>
      </ul>
    </div>
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$parent.$emit('count', x)"></quick-setup>
    <b-tabs v-else v-model="tab_index">
      <b-tab no-body title="Site">
        <b-row>
          <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
            <b-card>
              <div slot="header">
                <strong>Site Info</strong>
                <span v-if="!add && model.created_at">( Registered : {{model.created_at | sdate}})</span>
                <span class="float-right" v-if="!add && model.last_visit">Last Visit : {{model.last_visit | sdate}}</span>
                <span class="float-right" v-else> - </span>
              </div>
              <b-row>
                <b-col md="2" v-if="add" style="cursor:pointer">
                  <b-form-group>
                    <label v-b-tooltip.hover title="Start site registration and check">
                      Start at registration
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_start" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2" v-else>
                  <b-form-group>
                    <label v-b-tooltip.hover title="Set scan enable or disable">
                      Enable
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <label v-b-tooltip.hover title="Toggle js click event trigger">
                      JS Event
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_js" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                  <label v-b-tooltip.hover title="Set Login enable or disable">
                    Login Enable
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <br>
                    <c-switch color="info" label size="sm" v-model="model.is_login" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="5" v-show="!add && lock">
                  <b-form-group>
                    <label v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                      Check Policy
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <p>{{policy.description}}</p>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-show="!lock">
                  <b-form-group>
                    <label for="ph_schedule_type" v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                      Check Policy
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                      <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_username" v-b-tooltip.hover title="Specifies the name that separates the site">
                      Name
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                    <hr>
                    <b-input-group class="text-center">
                      <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                      <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <label
                    style="cursor:pointer"
                    v-b-tooltip.hover.hover:title="`URLs to be checked or main pages to be checked or URLs of pages to be checked`"
                  >
                    Check Start URL (max 10)
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend><b-input-group-text> Start From </b-input-group-text></b-input-group-prepend>
                      <b-form-input id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, ex) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">Add</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="'_seed_'+index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      v-b-tooltip.hover.hover:title="`Set the inspection cycle, It is recommended that you check at least once a day at a time when there are fewer people accessing the site`"
                      style="cursor:pointer"
                    >
                      Check Schedule
                      <span class="text-info">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </label>
                    <small>Max :{{max_schedule}}</small>
                    <hr>
                    * <b-badge variant="warning">Notice</b-badge>
                    : Site availability and over-checking can be limited to up to 24 times a day
                    <hr>
                    <b-input-group>
                      <!-- <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select> -->
                      <b-form-select v-if="i18n" ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt[i18n]" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-if="i18n" v-model="s.m" :options="s.m_opt[i18n]" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(schedule, index) in model.schedule" :key="'_sch_'+index">
                        <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                        ({{ schedule }}) {{ cron_filter(schedule) }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <strong>Additional information</strong>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_sub_domain"
                      v-b-tooltip.hover.hover title="Register if subdomain exists within the same site ex) admin.f1security.co.kr"
                    >
                      Sub Domain
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="Domain" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                      <b-button class="btn-addition" variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">Add</b-button>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(sub, index) in model.config.subs" :key="'_sub_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="Specifies the path to which the exception should be processed(can not match the parts) ex) /admin/download">
                      Exception Path
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="subroutine path" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">Add</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="'_prevent_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="Enter a word to be treated as an exception with a regular Expression(can match the parts) ex) (edit|remove)">
                      Exception Regex
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-input class="text-center border" v-model="model.regex" placeholder="support regex format" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <hr>
              <template v-if="lock">
                <template v-if="model.is_del">
                  <b-button size="sm" variant="success" @click="revive"> Recover </b-button>
                  <span>Recover</span>
                </template>
                <template v-else>
                  <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
                  <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
                </template>
              </template>
              <template v-else>
                <b-button size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
                <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
              </template>
              <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>  -->
            </b-card>
          </b-col>
          <!-- </b-row> -->
          <!-- </b-col> -->
          <!-- policy start -->
          <b-col lg="12" xl="4" v-if="isLoadPolicy">
            <b-card>
              <div slot="header">
                <strong>Policy</strong>
                <small class="float-right">info read only</small>
              </div>
              <b-row class="text-center">
                <b-col md="12">
                  <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
                  <hr>
                  <small>
                    This page is Only showing policy information, can change on policy edit page.
                  </small>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group v-b-tooltip.hover.hover :title="`Enter whether to check by moving (path) the link from the first page to the next. The default value for Quick Setup is ${policy.depth}`">
                    <b-input-group-prepend><b-input-group-text> Maximum path depth &nbsp;
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span> </b-input-group-text></b-input-group-prepend>
                    <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
                </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    Enter the maximum sublink to navigate within a page.
                    Ignore any excess links.
                    Normally if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way.
                    The default value for Quick Setup is ${policy.links}`"
                  >
                      <b-input-group-prepend><b-input-group-text> Sub Page Link &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    Total number of pages to check on the inspection site.
                    End the check when the entered number is reached.
                    can be specified within the range of 1 to license limit.
                    The default value for Quick Setup is ${policy.limit}`"
                  >
                      <b-input-group-prepend><b-input-group-text> Maximum Navigation Page &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    Time to wait for page loading.
                    can be specified within the range of 1-30.
                    The default value for Quick Setup is ${policy.timeout}`"
                  >
                      <b-input-group-prepend><b-input-group-text> TimeOut(Second) &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    Time to wait before moving to a new page.
                    can be specified within the range of 1 to 10 000.
                    The default value for Quick Setup is ${policy.delay}`"
                  >
                      <b-input-group-prepend><b-input-group-text> Check Speed(Millisecond) &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <template>
                <b-button class="btn-add" block size="sm" variant="success" @click="policy_manage"> Manage </b-button>
              </template>
            </b-card>
            <!-- result start -->
            <b-card>
              <div slot="header" class="text-center">
                <strong v-if="result.page_count > 0">Have the latest inspection results.</strong>
                <strong v-else>don't have a recent check history. </strong>
              </div>
              <template>
                <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> Check it </b-button>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <hr>
        <template v-if="lock">
          <template v-if="model.is_del">
            <b-button class="btn-add" size="sm" variant="success" @click="revive"> Recover </b-button>
            <span>Recover</span>
          </template>
          <template v-else>
            <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
          </template>
        </template>
        <template v-else>
          <b-button class="btn-add" size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
          <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
        </template>
        <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
      </b-card>
    </b-tab>
    <b-tab no-body title="Login Option" :disabled="!model.is_login">
      <vcl-facebook v-if="loading"></vcl-facebook>
      <b-card v-else>
        <template slot="header">
          <label v-b-tooltip.hover title="Enter account information when checking pages that require login">
            <strong>WMDS Login Configuration</strong>
            <span>
              <i style="cursor:pointer" class="fas fa-question-circle"></i>
            </span>
          </label>
        </template>
        <b-row>
          <b-col lg="11" xl="11">
            <b-form-group>
              <b-input-group class="text-center">
                <b-input-group-prepend><b-input-group-text> Login Page </b-input-group-text></b-input-group-prepend>
                <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" ref="login_url" id="login_url" placeholder="Login URL : ex) http://www.f1security.co.kr/login.do" v-model="model.login_url" :plaintext="lock" @change="check_login"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="iframe" v-b-tooltip.hover title="site was configuration with iframe">
              <c-switch color="info" label size="sm" v-model="opt_login.is_iframe" :disabled="lock" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group class="text-center">
                <b-button class="m-2" size="sm" variant="primary" @click="test" :disabled="lock"> 1. Login page crawling </b-button>
                  <p class="m-2">(</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(0)" :disabled="lock"> 2. information gathering with load javascript, css </b-button>
                  <p class="m-2">or</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(1)" :disabled="lock"> 2. information gathering with no load javascript, css </b-button>
                  <p class="m-2">)</p>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <span class="text-danger">* When checking using the login function, add the above exception path to avoid the function (deletion, addition, etc.)</span>
            <br>
            <span class="text-danger">* If you can't complete the login information collection normally, please enter it manually.</span>
            <br>
            <span class="text-danger">* Initialization is recommended when collecting new account information.</span>
            <hr>
            <strong>
              Support message : {{ !lock ? (opt_login_msg || '-') : '-' }}
            </strong>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-button block class="m-2" size="sm" variant="warning" @click="() => { opt_login.username = ''; opt_login.password = ''; opt_login.el_password = ''; opt_login.el_username = ''; opt_login.el_submit = ''; }" :disabled="lock"> Reset </b-button>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend>
                    <b-input-group-text> Username unique string </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_username" :state="(opt_login.el_username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Username value </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.username" :state="(opt_login.username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Password unique string </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_password" :state="(opt_login.el_password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-input-group-prepend style="display:inline-block;text-align:left; float:left;">
                    <b-input-group-text> Password value </b-input-group-text>
                  </b-input-group-prepend>
                  <b-input-group-prepend style="display:inline-block;text-align:right;float:right;">
                    <b-checkbox :disabled="lock" class="float-right" v-model="opt_login.is_show">show</b-checkbox>
                  </b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" :type="opt_login.is_show ? 'text' : 'password'" v-model="opt_login.password" :state="(opt_login.password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Login Button unique string </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_submit" :state="(opt_login.el_submit.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <template v-if="lock && !loading">
        <template v-if="model.is_del">
          <b-button class="btn-add" size="sm" variant="success" @click="revive"> Recover </b-button>
          <span>Recover</span>
        </template>
        <template v-else>
          <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
          <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
        </template>
      </template>
      <template v-if="!lock && !loading">
        <b-button class="btn-add" size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
        <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
      </template>
      <b-button v-if="!loading" size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
    </b-tab>
  </b-tabs>
    <!-- delete modal -->
    <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> Delete registered sites for checks </p>
      <p>
        If it is deleted, it is not possible to check the distribution location of the malicious code and its suspension.
      </p>
      <p> Are you sure you want to delete it? </p>
      <p> <b> * Check Site Name </b> </p>
      <p> Delete Site Name : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="Site Result"  class="modal-primary" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xl" title="Information"  class="modal-info" v-model="modal_explain" hide-footer ok-variant="success">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>Charging will begin when the first site registration is made and scanning started.</h5>
      <hr>
      <!-- <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a> -->
      <hr>
      Please refer to the terms and conditions for details.
      <h6> <b>Are you sure agree?</b></h6>
    </b-modal>
    <b-modal v-model="opt_login.explain" title="Login Option Explain" @ok="opt_login.modal_explain = false" no-close-on-backdrop header-bg-variant="info">
      <h6>
        In the case of sites requiring login, an inspection account is issued to check the sites requiring login through the account login during inspection.
      </h6>
    </b-modal>
    <b-modal v-model="opt_login.modal_props" title="Choice unique string of tag property" @ok="opt_login.modal_props = false" no-close-on-backdrop header-bg-variant="info" hide-footer>
      <h6>
        <b-form-group>

          <table class="table table-sm">
            <th>No.</th>
            <th>Unique string</th>
            <tr v-for="(item, index) in opt_login.props" :key="'_probs_'+index">
                <td> {{ index + 1 }} </td>
                <td>
                  <b-form-radio v-model="opt_login.sel_props" name="props" :value="item"> {{ item }} </b-form-radio>
                </td>
            </tr>
            <tr v-if="!opt_login.props">
              <td colspan="2"> no have info </td>
            </tr>
          </table>
          <hr class="w-100">
          <b-button class="btn-add" block :disabled="!opt_login.props" size="sm" variant="success" @click="opt_login_select()"> Next </b-button>
        </b-form-group>
      </h6>
      <hr>
    </b-modal>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
